module.exports = __webpack_public_path__ + "static/img/Captura de tela de 2024-11-05 15-08-19.2eda5e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Captura de tela de 2024-11-05 15-08-19.png
// module id = /o+F
// module chunks = 4